"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskedPhoneValidator = void 0;
exports.maskedPhoneValidator = new RegExp(/^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/);
